"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleStatusCode = exports.DOGGY_PAGE_STATUS_CODES = void 0;
const constants_1 = require("../../constants");
exports.DOGGY_PAGE_STATUS_CODES = ['400', '404', '429', '500'];
const handleStatusCode = (req, res) => {
    const statusCodeString = req.params[constants_1.STATUS_CODE_PARAM] || '';
    let statusCode = 403;
    let body = '';
    const IS_LOCAL = constants_1.ENV_STAGE === 'local';
    if (exports.DOGGY_PAGE_STATUS_CODES.includes(statusCodeString)) {
        statusCode = parseInt(statusCodeString);
    }
    if (IS_LOCAL) {
        body = `${statusCodeString} Error: ShoppingPortal will place doggy page here`;
    }
    res.status(statusCode).send(body);
};
exports.handleStatusCode = handleStatusCode;
